import { useI18n } from "../i18n/I18nProvider";
import { IconFlexible, IconOperational, IconPrime } from "./icons";

/**
 * Frame 156:45. 220px band with 28px vertical and 72px side padding, three
 * 416x164 cards 24px apart. The icon tile is 58x58 at the right edge of every
 * card in both locales, and the text block sits left of it, right-aligned in
 * Arabic.
 */
export function FeatureCards() {
  const { copy, direction } = useI18n();
  const cards = [
    { key: "operational", icon: <IconOperational />, ...copy.features.operational },
    { key: "flexible", icon: <IconFlexible />, ...copy.features.flexible },
    { key: "prime", icon: <IconPrime />, ...copy.features.prime },
  ];

  return (
    <section className="bg-surface-2" aria-label={copy.features.operational.title}>
      <div
        dir="ltr"
        className="flex flex-col gap-3 mx-auto w-full max-w-[1440px] px-[18px] lg:px-[72px] py-[22px] lg:flex-row lg:gap-6 lg:py-7"
      >
        {cards.map((card) => (
          <div
            key={card.key}
            data-reveal
            className="flex items-center gap-3 rounded-2xl border border-line-2 bg-white p-4 lg:h-[164px] lg:flex-1 lg:gap-[18px] lg:px-[21px] lg:py-4"
          >
            <div
              dir={direction}
              className={`flex min-w-0 flex-1 flex-col gap-[5px] ${
                direction === "rtl" ? "items-end text-end" : "items-start text-start"
              }`}
            >
              <h3 className="text-[17px] font-bold leading-[24px] text-navy lg:text-[20px] lg:leading-[30px]">
                {card.title}
              </h3>
              <p className="text-[13px] leading-[24px] text-body-2 lg:text-[14px] lg:leading-[26px]">
                {card.caption}
              </p>
            </div>
            <span className="flex h-[52px] w-[52px] shrink-0 items-center justify-center rounded-[14px] bg-tint text-[28px] text-icon lg:h-[58px] lg:w-[58px] lg:text-[30px]">
              {card.icon}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
